var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.componentStyles),attrs:{"id":"pdf"}},[_c(_vm.component,_vm._b({ref:"pdfContent",tag:"component"},'component',_vm.componentProps,false))],1),_vm._v(" "),_c('loader-pdf',{ref:"loaderPdf"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-998e8212","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Pdf.vue
// module id = 2109
// module chunks = 2